function buildResponse(error, description) {
  return {
    error: error,
    errorDescription: description
  };
}

function invalidToken(description) {
  return buildResponse('invalid_token', description);
}

module.exports = {
  buildResponse: buildResponse,
  invalidToken: invalidToken
};



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/src/helper/error.js
// module id = 463
// module chunks = 0